__turbopack_context__.v({
  "button": "index-module-scss-module__QnN1zq__button",
});
